import ExhibitionSelectModal from "./exhibition-select-modal";


const ExhibitionModals = {
    Select : ExhibitionSelectModal
}

export default ExhibitionModals;